import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError, TimeoutError } from 'rxjs';

@Injectable()
export class HttpTimeoutInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((err: Error) => {
        if (
          err instanceof TimeoutError ||
          (err instanceof HttpErrorResponse && err.status === 500) ||
          (err instanceof HttpErrorResponse && err.status === 504)
        ) {
          this.router.navigate([
            '/timeout',
            {
              origin: this.router.url,
              error: err.message,
              requestPath: req?.url,
              requestMethod: req?.method,
            },
          ]);
          return throwError(() => err);
        }

        return throwError(() => err);
      })
    );
  }
}
